$(function () {
  const prevArrow = $('.js-achievements-prev-btn')
  const nextArrow = $('.js-achievements-next-btn')

  $('.js-achievements-slider').slick({
    slidesToShow: 1,
    arrows: true,
    asNavFor:
      '.js-prize-slider, .js-achievements-content, .js-achievements-thumbnail',
    prevArrow: !!prevArrow.length && prevArrow,
    nextArrow: !!nextArrow.length && nextArrow,
    autoplay: false,
    responsive: [
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  })

  $('.js-prize-slider').slick({
    slidesToShow: 1,
    arrows: false,
    swipe: false,
    fade: true,
  })

  $('.js-achievements-content').slick({
    slidesToShow: 1,
    arrows: false,
    asNavFor: '.js-achievements-thumbnail',
    swipe: false,
    fade: true,
    adaptiveHeight: true,
  })

  $('.js-achievements-thumbnail').slick({
    variableWidth: true,
    slidesToShow: 7,
    arrows: false,
    vertical: false,
    focusOnSelect: true,
    verticalSwiping: false,
    autoplay: false,
    centerMode: false,
    asNavFor: '.js-achievements-slider',
    swipe: false,
    responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  })

  if (window.matchMedia('(max-width: 1023px)').matches) {
    $('.js-achievements-thumbnail').on(
      'beforeChange',
      function (event, slick, currentSlide, nextSlide) {
        $('.js-cup-slider-mob').slick('slickGoTo', nextSlide)
        $('.js-achievements-content').slick('slickGoTo', nextSlide)
      },
    )

    $('.js-cup-slider-mob').slick({
      slidesToShow: 1,
      arrows: false,
      dots: false,
    })
  } else {
    $('.js-achievements-thumbnail').on(
      'beforeChange',
      function (event, slick, currentSlide, nextSlide) {
        $('.js-cup-slider').slick('slickGoTo', nextSlide)
        $('.js-achievements-content').slick('slickGoTo', nextSlide)
      },
    )

    $('.js-cup-slider').slick({
      slidesToShow: 1,
      arrows: false,
      dots: false,
    })
  }
})
